// determine number of tasks in training-set in order to get max for progress bar
// 12.02.24: - if only 1 (rather than 3) spelling step - the total number of task returned is modified accordingly


import { get } from 'svelte/store';
import { Level } from '../enums';
import { totalNumberOfTasksBaseLevels, totalNumberOfTasksVerbExtension, totalNumberOfTasksSubjectExtension, totalNumberOfTasksBaseLevelsSimpleSpelling, totalNumberOfTasksVerbExtensionSimpleSpelling, totalNumberOfTasksSubjectExtensionSimpleSpelling } from "../constants";
import { studentUserData } from "../stores/user-store.svelte";

export const getTotalNumberOfTasks = (level: Level): number => {
  if (level === Level.First || level === Level.Second || studentUserData.value.settings.doIntroNextSession || studentUserData.value.settings.doTestNextSession) {
    return studentUserData.value.settings.simpleSpelling ? totalNumberOfTasksBaseLevelsSimpleSpelling : totalNumberOfTasksBaseLevels;
  } else if (level === Level.SecondVerb) {
    return studentUserData.value.settings.simpleSpelling ? totalNumberOfTasksVerbExtensionSimpleSpelling : totalNumberOfTasksVerbExtension;
  } else if (level === Level.SecondSubject) {
    return studentUserData.value.settings.simpleSpelling ? totalNumberOfTasksSubjectExtensionSimpleSpelling : totalNumberOfTasksSubjectExtension
  } else {
    console.error("error in: getTotalNumberOfTasks, level: ", level)
    return totalNumberOfTasksBaseLevels;
  }
}